/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SearchIn = {
    country: SearchIn.country;
    search_str: string;
    state?: ('' | string | null);
};
export namespace SearchIn {
    export enum country {
        US = 'US',
        IE = 'IE',
        GB = 'GB',
        AU = 'AU',
        CA = 'CA',
        ES = 'ES',
        NL = 'NL',
        BE = 'BE',
        DK = 'DK',
        SE = 'SE',
        NZ = 'NZ',
        DE = 'DE',
        FR = 'FR',
    }
}

